import { Directive, ElementRef, OnInit, inject } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'vwui-table:not([breakpoint])',
    standalone: false
})
export class VwuiTableDefaultBreakpointDirective implements OnInit {
    private elementRef = inject<ElementRef<HTMLVwuiTableElement>>(ElementRef);


    ngOnInit() {
        this.elementRef.nativeElement.setAttribute('breakpoint', 'xs');
    }

}
